import { IonContent, IonFooter, IonHeader, IonModal } from '@ionic/react'
import React from 'react'
import { observer } from 'mobx-react'
import { cartMobx } from 'restaurant'
import { ddayjs, format, toPriceLittleCurrency } from '@dt/fe-utils'
import './index.scss'

interface IProps {
  reject?: () => void;
  resolve?: (product: any) => void;
}

const ExpressPriceModal: React.FC<IProps> = (props) => {
  const ExpressPrice = (item: IExpressInfo) => (
    <div className='bpm-item'>
      <span>{i18n.t('newCart.timeFor_delivery', { time: ddayjs(item.startTime).format('YYYY-MM-DD HH:mm') })}</span>
      <span>{format.toPrice(item.price)}</span>
    </div>
  )

  const handleClose = () => {
    props.reject()
  }

  return (
    <IonModal
      cssClass='express-price-modal'
      isOpen
      showBackdrop
      swipeToClose
      backdropDismiss={false}
    >
      <IonHeader>
        <div className='bpm-title'>{i18n.t('result.expressPriceDetail')}</div>
      </IonHeader>
      <IonContent className='bpm-content'>
        <div className='bpm-list'>
          {cartMobx.info.expressList.map(item => (
            <ExpressPrice key={item.pk} {...item} />
          ))}
        </div>
        <div className='bpm-total'>
          <span>{i18n.t('cart.total')} </span>
          <span dangerouslySetInnerHTML={{ __html: toPriceLittleCurrency(cartMobx.cartResult.expressPrice) }}></span>
        </div>
      </IonContent>
      <IonFooter className='bpm-footer'>
        <button className='default-btn' data-cypid='expressPriceModalClose' onClick={handleClose}>
          {i18n.t('common.back')}
        </button>
      </IonFooter>
    </IonModal>
  )
}

export default observer(ExpressPriceModal)
